import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

export const ootdPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{rose.50}',
      100: '{rose.100}',
      200: '{rose.200}',
      300: '{rose.300}',
      400: '{rose.400}',
      500: '{rose.500}',
      600: '{rose.600}',
      700: '{rose.700}',
      800: '{rose.800}',
      900: '{rose.900}',
      950: '{rose.950}',
    },
    colorScheme: {
      light: {
        surface: {
          50: '{neutral.950}',
          100: '{neutral.900}',
          200: '{neutral.800}',
          300: '{neutral.700}',
          400: '{neutral.600}',
          500: '{neutral.500}',
          600: '{neutral.400}',
          700: '{neutral.300}',
          800: '{neutral.200}',
          900: '{neutral.100}',
          950: '{neutral.50}',
        },

        primary2: {
          50: '{rose.50}',
          100: '{rose.100}',
          200: '{rose.200}',
          300: '{rose.300}',
          400: '{rose.400}',
          500: '{rose.500}',
          600: '{rose.600}',
          700: '{rose.700}',
          800: '{rose.800}',
          900: '{rose.900}',
          950: '{rose.950}',
        },
      },
      dark: {
        surface: {
          50: '{neutral.50}',
          100: '{neutral.100}',
          200: '{neutral.200}',
          300: '{neutral.300}',
          400: '{neutral.400}',
          500: '{neutral.500}',
          600: '{neutral.600}',
          700: '{neutral.700}',
          800: '{neutral.800}',
          900: '{neutral.900}',
          950: '{neutral.950}',
        },

        primary2: {
          50: '{rose.800}',
          100: '{rose.700}',
          200: '{rose.600}',
          300: '{rose.500}',
          400: '{rose.400}',
          500: '{rose.300}',
          600: '{rose.200}',
          700: '{rose.100}',
          800: '{rose.50}',
          900: '{rose.50}',
          950: '{rose.50}',
        },

      }
    }
  }
});
